/* tslint:disable */
/* eslint-disable */
/**
 * Bfree API
 * API Documentation for B&Free Project
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    SupportReport,
    SupportReportFromJSON,
    SupportReportToJSON,
} from '../models';

export interface ApiSupportReportsIdDeleteRequest {
    id: number;
}

export interface ApiSupportReportsIdGetRequest {
    id: string;
}

export interface ApiSupportReportsIdPutRequest {
    id: number;
    supportReport: SupportReport;
}

export interface ApiSupportReportsPostRequest {
    supportReport: SupportReport;
}

/**
 * 
 */
export class SupportReportsApi extends runtime.BaseAPI {

    /**
     */
    async apiSupportReportsGetRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<SupportReport>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("passport", []);
        }

        const response = await this.request({
            path: `/api/support_reports`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SupportReportFromJSON));
    }

    /**
     */
    async apiSupportReportsGet(initOverrides?: RequestInit): Promise<Array<SupportReport>> {
        const response = await this.apiSupportReportsGetRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async apiSupportReportsIdDeleteRaw(requestParameters: ApiSupportReportsIdDeleteRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling apiSupportReportsIdDelete.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("passport", []);
        }

        const response = await this.request({
            path: `/api/support_reports/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiSupportReportsIdDelete(requestParameters: ApiSupportReportsIdDeleteRequest, initOverrides?: RequestInit): Promise<void> {
        await this.apiSupportReportsIdDeleteRaw(requestParameters, initOverrides);
    }

    /**
     */
    async apiSupportReportsIdGetRaw(requestParameters: ApiSupportReportsIdGetRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<SupportReport>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling apiSupportReportsIdGet.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("passport", []);
        }

        const response = await this.request({
            path: `/api/support_reports/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportReportFromJSON(jsonValue));
    }

    /**
     */
    async apiSupportReportsIdGet(requestParameters: ApiSupportReportsIdGetRequest, initOverrides?: RequestInit): Promise<SupportReport> {
        const response = await this.apiSupportReportsIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiSupportReportsIdPutRaw(requestParameters: ApiSupportReportsIdPutRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling apiSupportReportsIdPut.');
        }

        if (requestParameters.supportReport === null || requestParameters.supportReport === undefined) {
            throw new runtime.RequiredError('supportReport','Required parameter requestParameters.supportReport was null or undefined when calling apiSupportReportsIdPut.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("passport", []);
        }

        const response = await this.request({
            path: `/api/support_reports/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: SupportReportToJSON(requestParameters.supportReport),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiSupportReportsIdPut(requestParameters: ApiSupportReportsIdPutRequest, initOverrides?: RequestInit): Promise<void> {
        await this.apiSupportReportsIdPutRaw(requestParameters, initOverrides);
    }

    /**
     */
    async apiSupportReportsPostRaw(requestParameters: ApiSupportReportsPostRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.supportReport === null || requestParameters.supportReport === undefined) {
            throw new runtime.RequiredError('supportReport','Required parameter requestParameters.supportReport was null or undefined when calling apiSupportReportsPost.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("passport", []);
        }

        const response = await this.request({
            path: `/api/support_reports`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SupportReportToJSON(requestParameters.supportReport),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiSupportReportsPost(requestParameters: ApiSupportReportsPostRequest, initOverrides?: RequestInit): Promise<void> {
        await this.apiSupportReportsPostRaw(requestParameters, initOverrides);
    }

}
